import { BaseIntegration, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { Component } from 'vue';
import { IntegrationClerkData } from './Data';

export interface IntegrationClerkState extends BaseIntegrationState {
  apiKey?: string;
}

export class IntegrationClerkModel extends BaseIntegration<IntegrationClerkData, IntegrationClerkState> {
  parse(data: IntegrationClerkData) {
    super.parse(data);

    if (data.settings?.clerk) {
      this.state.apiKey = data.settings?.clerk?.api_key;
    } else {
      this.state.apiKey = undefined;
    }
  }

  getVueComponent(): Promise<Component> {
    return import('@/components/integrations/clerk/View.vue');
  }

  hasVueComponent() {
    return true;
  }

  authorSignature(): string {
    return 'Istvan Bovan';
  }
}
